import React, {useCallback, useRef, useState} from 'react'
import {Outlines, useGLTF} from '@react-three/drei'
import {INFO_PANEL_DATA, TARGET_BOX_PROPS} from '../utils/constants.jsx'
import {useAppStore} from '../stores/store.js'
import * as THREE from 'three'
import {usePulsatingOutline} from '../hooks/usePulsatingOutline.jsx'
import {useThree} from '@react-three/fiber'
import {SelectionHover} from './SelectionHover.jsx'

export function TargetModel() {
    const {nodes, materials} = useGLTF('./models/target_s.glb')
    const targetRef = useRef(null)
    const [hovered, setHovered] = useState(false)
    const {camera, size} = useThree()

    const outlineThickness = usePulsatingOutline(0.01, 0.03, 2); // Adjust values as needed

    const handleClick = useCallback((event) => {
        event.stopPropagation()

        if (!targetRef.current || !camera || !size.width || !size.height) {
            console.warn('Click skipped: Missing refs, handlers, or camera/size info.')
            return
        }

        const {focusOnObject, selectObject} = useAppStore.getState()

        // Get World Position
        const worldPos = new THREE.Vector3()
        targetRef.current.getWorldPosition(worldPos)

        const cameraFocusOffset = new THREE.Vector3(-2, 1, -5)
        focusOnObject(worldPos, cameraFocusOffset)
        selectObject(INFO_PANEL_DATA.target.id)

    }, [camera, size])

    const handlePointerEnter = useCallback((e) => {
        e.stopPropagation()
        setHovered(true)
        document.body.style.cursor = 'pointer'
    }, [])

    const handlePointerOut = useCallback((e) => {
        e.stopPropagation()
        setHovered(false)
        document.body.style.cursor = 'default'
    }, [])

    return (
        <>
            <group scale={3} position={[13.1, 11.1, 7.5]} rotation={[0.5, 0.7, 0]} dispose={null}>
                <group>
                    <mesh
                        geometry={nodes.target_1.geometry}
                    >
                        <meshBasicMaterial color={materials.red.color}/>
                        <Outlines thickness={outlineThickness} color='white' screenspace={true}/>
                    </mesh>
                    <mesh
                        geometry={nodes.target_2.geometry}
                    >
                        <meshBasicMaterial color={materials.white.color}/>
                    </mesh>
                </group>
            </group>
            <mesh
                position={TARGET_BOX_PROPS.position}
                scale={TARGET_BOX_PROPS.scale}
                ref={targetRef}
                onPointerEnter={handlePointerEnter}
                onPointerOut={handlePointerOut}
                onClick={handleClick}
            >
                <boxGeometry/>
                <meshBasicMaterial
                    visible={false}
                    // color='blue'
                    // opacity={0.5}
                    // transparent={true}
                />
            </mesh>
            <SelectionHover
                objectRef={targetRef}
                hovered={hovered}
                cornerSize={0.5}
                padding={0.02}
            />
        </>
    )
}


useGLTF.preload('./models/target_s.glb')

